import { ref } from 'vue';

const topicMenuState = ref(null);
const topicDialogState = ref(null);

const eventPosition = event => {
  let x = event.pageX || event.clientX;
  let y = event.pageY || event.clientY;
  if (!x && !y && event.currentTarget?.getBoundingClientRect) {
    const rect = event.currentTarget.getBoundingClientRect();
    x = rect.left + rect.width / 2;
    y = rect.bottom;
  }
  return { x, y };
};

export const movedTopicIds = (topics, topicId, delta) => {
  const ids = topics.map(topic => topic.id);
  const from = ids.indexOf(Number(topicId));
  const to = from + delta;
  if (from < 0 || to < 0 || to >= ids.length) return null;
  [ids[from], ids[to]] = [ids[to], ids[from]];
  return ids;
};

export const validTopicForm = (name, labelIds) =>
  Boolean(name.trim()) && labelIds.length > 0;

export function useSidebarTopicMenu() {
  const openTopicMenu = (id, event) => {
    topicMenuState.value = { id: Number(id), ...eventPosition(event) };
  };
  const closeTopicMenu = () => {
    topicMenuState.value = null;
  };
  return { topicMenuState, openTopicMenu, closeTopicMenu };
}

export function useSidebarTopicDialog() {
  const openCreateTopicDialog = () => {
    topicDialogState.value = { mode: 'create', topicId: null };
  };
  const openEditTopicDialog = topicId => {
    topicDialogState.value = { mode: 'edit', topicId: Number(topicId) };
  };
  const closeTopicDialog = () => {
    topicDialogState.value = null;
  };
  return {
    topicDialogState,
    openCreateTopicDialog,
    openEditTopicDialog,
    closeTopicDialog,
  };
}
